import { render, staticRenderFns } from "./OrderNewList.vue?vue&type=template&id=76572dfd"
import script from "./OrderNewList.js?vue&type=script&lang=js&external"
export * from "./OrderNewList.js?vue&type=script&lang=js&external"
import style0 from "./OrderNewList.vue?vue&type=style&index=0&id=76572dfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports